import {
  CommonComorbidityNames,
  CommonComorbidityNamesByNctId,
} from '@components/app/TrialApply/const'

/**
 * Common comorbidities to display in comorbidities question in Apply Flow
 * Checks if there are any comorbidities specific to the trial
 * Else, returns default common comorbidities
 *
 * @param {string | undefined} nctId - NCT ID of trial
 * @returns {string[]} Names of common comorbidities
 */
export function getCommonComorbidities({ nctId }: { nctId?: string }) {
  const trialSpecificComorbidityNames = nctId
    ? CommonComorbidityNamesByNctId.filter((item) =>
        item.nctIds.includes(nctId),
      )
    : []

  if (trialSpecificComorbidityNames.length > 0) {
    return trialSpecificComorbidityNames.flatMap((item) => item.comorbidities)
  }

  // if we don't know the trial, return default common comorbidities
  return CommonComorbidityNames
}
